var React = require('react');

function Dashboard (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 12C3 12.5523 3.44772 13 4 13H10C10.5523 13 11 12.5523 11 12V4C11 3.44772 10.5523 3 10 3H4C3.44772 3 3 3.44772 3 4V12ZM3 20C3 20.5523 3.44772 21 4 21H10C10.5523 21 11 20.5523 11 20V16C11 15.4477 10.5523 15 10 15H4C3.44772 15 3 15.4477 3 16V20ZM13 20C13 20.5523 13.4477 21 14 21H20C20.5523 21 21 20.5523 21 20V12C21 11.4477 20.5523 11 20 11H14C13.4477 11 13 11.4477 13 12V20ZM14 3C13.4477 3 13 3.44772 13 4V8C13 8.55228 13.4477 9 14 9H20C20.5523 9 21 8.55228 21 8V4C21 3.44772 20.5523 3 20 3H14Z","fill":"currentColor"}));
}

Dashboard.displayName = "Dashboard";

Dashboard.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 24 24"};

module.exports = Dashboard;

Dashboard.default = Dashboard;
